import React, { Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from './Layout';

const pageLoader = (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--surface-primary)',
      color: 'var(--text-secondary)',
    }}
  >
    Loading…
  </div>
);

export default function ProtectedLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return pageLoader;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!user.onboarding_completed && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <Suspense
      fallback={
        <div style={{ display: 'flex', background: 'var(--surface-primary)', minHeight: '100vh' }}>
          <div style={{ width: 240, background: 'var(--surface-secondary)' }} />
          <main style={{ flex: 1, padding: 24, color: 'var(--text-secondary)' }}>Loading page…</main>
        </div>
      }
    >
      <Layout />
    </Suspense>
  );
}
